import React from 'react';
import './MapOverlaySelector.css';

const OVERLAYS = [
  { key: 'none', label: 'Properties' },
  { key: 'alerts', label: 'Weather Alerts' },
  { key: 'drought', label: 'Drought' },
  { key: 'fires', label: 'Fires' },
  { key: 'nifc', label: 'NIFC' },
];

/**
 * Simple segmented button group for switching the dashboard map overlay.
 */
function MapOverlaySelector({ active, onChange, loading = false }) {
  return (
    <div className="map-overlay-selector">
      {OVERLAYS.map(({ key, label }) => (
        <button
          key={key}
          className={`overlay-btn ${active === key ? 'active' : ''}`}
          onClick={() => onChange(key)}
          disabled={loading}
          aria-pressed={active === key}
        >
          {label}
        </button>
      ))}
      {loading && <span className="overlay-loading">Loading…</span>}
    </div>
  );
}

export default MapOverlaySelector;
